import { translate } from '@utils/i18n';
export const namespace = 'features.iim_run_initializer';
export const issueProcessorTypes = [
    {
        key: 'unanswered_questions',
        name: translate('processors.unanswered_questions', { namespace }),
        icon: 'fa-light fa-comments-question'
    },
    {
        key: 'missing_signatures',
        name: translate('processors.missing_signatures', { namespace }),
        icon: 'fa-light fa-comments-question'
    },
    {
        key: 'missing_deficiency_notes_photos',
        name: translate('processors.missing_deficiency_notes_photos', { namespace }),
        icon: 'fa-light fa-hammer-crash'
    },
    {
        key: 'missing_time_entries',
        name: translate('processors.missing_time_entries', { namespace }),
        icon: 'fa-light fa-user-clock'
    },
    {
        key: 'out_of_spec_values',
        name: translate('processors.out_of_spec_values', { namespace }),
        icon: 'fa-light fa-user-clock'
    },
    {
        key: 'severity_discrepancy',
        name: translate('processors.severity_discrepancy', { namespace }),
        icon: 'fa-light fa-user-clock'
    },
    {
        key: 'analyze_deficiency_notes',
        name: translate('processors.analyze_deficiency_notes', { namespace }),
        icon: 'fa-light fa-spell-check'
    },
    {
        key: 'inspection_timing_audit',
        name: translate('processors.inspection_timing_audit', { namespace }),
        icon: 'fa-light fa-business-time'
    },
    {
        key: 'proximity_check',
        name: translate('processors.proximity_check', { namespace }),
        icon: 'fa-light fa-business-time'
    },
    {
        key: 'asset_count_change',
        name: translate('processors.asset_count_change', { namespace }),
        icon: 'fa-light fa-list-ol'
    },
    {
        key: 'drifting_values',
        name: translate('processors.drifting_values', { namespace }),
        icon: 'fa-light fa-list-ol'
    },
    {
        key: 'ulc_reference_clause_check',
        name: 'ULC Reference Clause Check',
        icon: 'fa-light fa-list-ol'
    },
    {
        key: 'unresolved_prior_deficiencies',
        name: 'Unresolved Prior Deficiencies',
        icon: 'fa-light fa-list-ol'
    },
    {
        key: 'recurring_deficiencies',
        name: 'Recurring Deficiencies',
        icon: 'fa-light fa-list-ol'
    },
    {
        key: 'materials_services_incomplete',
        name: translate('processors.materials_services_incomplete', { namespace }),
        icon: 'fa-light fa-clipboard-list'
    }
];
export const visualCheckProcessorTypes = [
    {
        key: 'analyze_deficiency_photos',
        name: translate('processors.analyze_deficiency_photos', { namespace }),
        icon: 'fa-light fa-camera'
    },
    {
        key: 'signature_quality_check',
        name: translate('processors.signature_quality_check', { namespace }),
        icon: 'fa-light fa-signature'
    },
    {
        key: 'pump_curve_check',
        name: translate('processors.pump_curve_check', { namespace }),
        icon: 'fa-light fa-chart-line'
    },
    {
        key: 'duplicate_photo_detected',
        name: translate('processors.duplicate_photo_detected', { namespace }),
        icon: 'fa-light fa-copy'
    }
];
export const supplementalProcessorTypes = [];
export const visibilities = [
    {
        key: 'tech_and_back_office',
        name: translate('visibilities.tech_and_back_office', { namespace }),
        value: 0,
        default: true
    },
    {
        key: 'tech_only',
        name: translate('visibilities.tech_only', { namespace }),
        value: 1,
        default: false
    },
    {
        key: 'back_office_only',
        name: translate('visibilities.back_office_only', { namespace }),
        value: 2,
        default: false
    },
    {
        key: 'hidden',
        name: translate('visibilities.hidden', { namespace }),
        value: 3,
        default: false
    }
];
